module.exports = __webpack_public_path__ + "static/media/swingBottomImg2.3ba32b08.png";